<template lang="html">
  <v-layout row wrap class="sub-tab-color">
    <v-flex offset-md1 md10 pt-2 pb-2 >
      <span class="pull-left">
        Olá, <strong class="captalize">{{ userName }}</strong>, {{ registrationStatusMessage }}
      </span>
      <span @click="cadastro" class="pull-right link cadastro-red" v-if="status < 89">
        Continuar o cadastro
      </span>
      <v-progress-linear
        v-model="status"
        color="green"
        background-color="white"
        style="margin-top: 28px;margin-bottom: 8px;"
        ></v-progress-linear>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'register-status',
  methods: {
    cadastro () {
      this.$router.push('/Painel/Conta/Empresa/')
    }
  },
  computed: {
    registrationStatusMessage () {
      return this.$store.getters.registrationStatusMessage
    },
    userName () {
      return this.$store.getters.nome
    },
    status () {
      return this.$store.getters.status
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// RegisterStatus.vue?78dca1af